import './AppContentFooter.css'

function AppContentFooter() {
  const year = new Date().getFullYear()

  return (
    <footer className="app-content-footer" role="contentinfo">
      <div className="app-content-footer-inner">
        <img
          className="app-content-footer-logo"
          src="/logo.svg"
          alt=""
          width={17}
          height={20}
          decoding="async"
          aria-hidden
        />
        <span className="app-content-footer-brand">Replay</span>
        <span className="app-content-footer-dot" aria-hidden="true">
          ·
        </span>
        <span className="app-content-footer-copy">
          Copyright {year} © Replay
        </span>
        <span className="app-content-footer-dot" aria-hidden="true">
          ·
        </span>
      </div>
    </footer>
  )
}

export default AppContentFooter
